import { render } from "./MaterialProfile.vue?vue&type=template&id=a57f2bde&scoped=true"
import script from "./MaterialProfile.vue?vue&type=script&lang=js"
export * from "./MaterialProfile.vue?vue&type=script&lang=js"

import "./MaterialProfile.vue?vue&type=style&index=0&id=a57f2bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57f2bde"]])

export default __exports__